import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { AuthRepForm } from '../components/AuthRepForm'
import { IAuthRepsReducer, submitEditRep, IAuthRepsAction } from 'redux/reducers/auth-reps'

import { getUserData } from 'redux/reducers/users'
import { useTranslation } from 'react-i18next'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'
import { Component } from '@cms-max/medicare-api-sdk'

export const AuthRepEditForm = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const userData = useSelector(getUserData)
  const { t } = useTranslation('authRep')

  // TODO - run a check against window, pass `isEdit` prop to authRepForm
  return (
    <>
      <BreadCrumb
        backButtonText={t('navigation.backToMyReps')}
        backButtonLink='/account-settings/auth-rep'
        navAriaLabel={t('navigation.backToAuthRepMainPageAriaLabel')}
        siteActivityProps={{
          component: Component.AuthorizedRepresentative,
          clickData: {
            linkText: t('navigation.backToMyReps', { lng: 'en' }),
            linkUrl: buildAbsoluteMedicareMyUrl('/account-settings/auth-rep')
          }
        }}
      />
      <AuthRepForm
        isEdit
        isNewYorkResident={userData?.user?.mailingAddress?.state?.toLowerCase() === 'ny'}
        handleOnError={(data: IAuthRepsReducer) => {
          // form error
          console.log('error editing rep')
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        }}
        handleOnSubmit={async (data: IAuthRepsAction) => {
          // should dispatch a call and have success and error states (see step1 in MedicareComplaintForm component)
          const thunkResult = await dispatch(submitEditRep(data)) as any
          // send the data
          if (!thunkResult.error) {
            console.log('submit edit  ')
            history.push('/account-settings/auth-rep')
          } else {
            console.log('submit edit failed  ')
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
          }
        }}
        handleOnBack={() => {
          console.log('cancel edit')
          history.push('/account-settings/auth-rep')
        }}
      />
    </>
  )
}
